import { Pagination } from 'react-bootstrap';


interface Props {
    onNext: ({ start, hasPrevious}: { start?: string, hasPrevious: boolean }) => void ;
    onPrevious: ({ start, hadNext}: { start: string, hadNext: boolean }) => void ;
    previous: string[];
    next?: string;
}

const SmashPaginator = (props: Props) => {
    const handlePrevious = () => {
        props.onPrevious({
            start: props.previous[props.previous.length - 1],
            hadNext: props.previous[props.previous.length - 1] === 'firstPage' ? false : true 
        })
    };
    const handleNext = () => {
        props.onNext({ start: props.next, hasPrevious: true })
    };

    return (
        <div className="d-flex justify-content-end">
            <Pagination className='mb-0'>
                <Pagination.Prev disabled={props.previous.length === 0 } onClick={handlePrevious}>Previous</Pagination.Prev>
                <Pagination.Next disabled={!(props.next)} onClick={handleNext}>Next</Pagination.Next>
            </Pagination>
        </div>
    )
}

export default SmashPaginator